module.exports = __webpack_public_path__ + "static/media/easter.26008fdc.jpg";